module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_m_albino.f982f63c.png";